import { render, staticRenderFns } from "./TableStats.vue?vue&type=template&id=c2c28dd4&scoped=true&"
import script from "./TableStats.vue?vue&type=script&lang=js&"
export * from "./TableStats.vue?vue&type=script&lang=js&"
import style0 from "./TableStats.vue?vue&type=style&index=0&id=c2c28dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c28dd4",
  null
  
)

export default component.exports